/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import PropTypes from 'prop-types';
import React from 'react';
import Router from '../Router';
import RouterContext from './Context';

class Route extends React.Component {
  render() {
    let {children, ctx} = this.props;
    const {hash, params, path, querystring} = ctx;
    let prefix = path;
    let route = params[0] || '';
    if (route) {
      route = `/${route}`;
      prefix = prefix.slice(0, -route.length);
    }

    querystring && (route += `?${querystring}`);
    hash && (route += `#${hash}`);

    let context = {
      fullPrefix: this.context.prefix + prefix,
      params,
      prefix,
      route,
      router: this.context.router
    };

    if (React.isValidElement(children) && /function|object/.test(typeof children.type)) {
      children = React.cloneElement(children, ctx);
    }

    return <RouterContext.Provider value={context}>{children}</RouterContext.Provider>;
  }
}

Route.propTypes = {
  children: PropTypes.node,
  ctx: PropTypes.shape({
    fullPath: PropTypes.string,
    hash: PropTypes.string,
    params: PropTypes.object,
    path: PropTypes.string,
    query: PropTypes.object,
    querystring: PropTypes.string,
    router: PropTypes.instanceOf(Router)
  }),
  path: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

Route.defaultProps = {
  ctx: {}
};

Route.contextType = RouterContext;

export default Route;
